import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as assessments from '../../assessments'

export const RESOURCE = {
  payload: {
    description:
      'A performance assessment associated with an affiliate of a non-profit institution.',
    dimension: assessments.RESOURCE.payload,
    level: 0,
    name: 'Assessment',
    partialId: PartialId.Standard.create('assessment'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
